var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.observaciones,"items-per-page":5}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }